<div class="modal-header">
    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="cancel()">
        <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">Out Of Jurisdiction Registration History</h4>
</div>
<div class="modal-body">
    <div class="spinner" *ngIf="true != dataLoaded"></div>
    <h2 id="cmlOOSRegistration">Out Of Jurisdiction Registrations</h2>
            <p-table #dtCVPOOSR [value]="outOfJurisdictionRegistrations" styleClass="p-datatable-striped" [paginator]="true" [rows]="10">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Plate Number</th>
                        <th>Plate State</th>
                        <th>Expiration Date</th>
                        <th>Updated Date</th>
                        <th>Update By</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td [attr.colspan]="6">
                            No Permits Found
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-activeOutOfJurisdictionRegistration>
                    <tr>
                        <td>{{ activeOutOfJurisdictionRegistration.plateNumber }}</td>
                        <td>{{ activeOutOfJurisdictionRegistration.jurisdictionId | jurisdictionCode }}</td>
                        <td>{{ activeOutOfJurisdictionRegistration.expirationDate | shortDate }}</td>
                        <td>{{ activeOutOfJurisdictionRegistration.updatedDate | shortDate }}</td>
                        <td>{{ activeOutOfJurisdictionRegistration.updatedBy }}</td>
                    </tr>
                </ng-template>
            </p-table>
</div>
<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--default" type="button" (click)="cancel()">Close</button>
    </div>
</div>